import React from 'react';
import { Typography } from '@material-ui/core';
import { QRCodeSVG } from 'qrcode.react';
import { useShareUsingQRStyles } from './component.style';

export const ShareUsingQR = (props) => {
  const { headingText, qrCode } = props;
  const classes = useShareUsingQRStyles();

  return (
    <div className={classes.container}>
      {headingText && <Typography variant="h4">{headingText}</Typography>}
      <QRCodeSVG value={qrCode} height="5.7rem" width="5.7rem" />
    </div>
  );
};
